@let v = vm();

<section class="hd-info-sections">
  <div class="hd-info-sections__header">
    <h3 class="hd-info-sections__title">{{ v.title }}</h3>
    @if (v.subtitle) {
      <span class="hd-info-sections__title-subtitle">{{ v.subtitle }}</span>
    }
    @if (v.jumpToStripLabel && v.strip) {
      <button type="button" class="hd-info-sections__jump" (click)="scrollToStrip()">
        {{ v.jumpToStripLabel }}
      </button>
    }
    @if (v.headerActionLabel) {
      <button type="button" class="hd-info-sections__jump hd-info-sections__header-action"
              (click)="requestHeaderAction()">
        {{ v.headerActionLabel }}
      </button>
    }
  </div>

  @if (v.generalUrl) {
    <markdown class="hd-info-sections__markdown" [src]="v.generalUrl" />
  } @else if (v.generalMarkdown) {
    <markdown class="hd-info-sections__markdown" [data]="v.generalMarkdown" />
  }

  @if (v.strip; as strip) {
    <div class="hd-info-sections__strip">
      <div class="hd-info-sections__strip-head">
        <span class="hd-info-sections__strip-label">{{ strip.label }}</span>
        @if (hasShowAll()) {
          <button type="button" class="hd-info-sections__show-all" (click)="requestShowAll()">
            {{ strip.showAllLabel }}
          </button>
        }
      </div>
      @if (strip.chips.length > 0) {
        <div class="hd-info-sections__chips">
          @for (chip of strip.chips; track chip.sectionKey + '/' + (chip.partKey ?? '')) {
            <button type="button" class="hd-info-sections__chip" (click)="onChipClick(chip)">
              {{ chip.label }}
            </button>
          }
        </div>
      }
    </div>
  }

  @for (section of visibleSections(); track section.key) {
    <section class="hd-info-sections__section"
             [class.hd-info-sections__section--collapsible]="v.collapsible"
             [attr.data-section-key]="section.key">
      <header class="hd-info-sections__section-header"
              [class.hd-info-sections__section-header--toggle]="v.collapsible"
              [attr.role]="v.collapsible ? 'button' : null"
              [attr.tabindex]="v.collapsible ? 0 : null"
              [attr.aria-expanded]="v.collapsible ? isExpanded(section.key) : null"
              (click)="v.collapsible && toggleSection(section.key)"
              (keydown.enter)="v.collapsible && toggleSection(section.key)"
              (keydown.space)="v.collapsible && toggleSection(section.key)">
        @if (v.collapsible) {
          <i class="fas hd-info-sections__chevron"
             [class.fa-chevron-down]="isExpanded(section.key)"
             [class.fa-chevron-right]="!isExpanded(section.key)"
             aria-hidden="true"></i>
        }
        <h4 class="hd-info-sections__section-title">{{ section.label }}</h4>
        @if (section.subtitle) {
          <span class="hd-info-sections__section-subtitle">{{ section.subtitle }}</span>
        }
        @if (section.badges.length > 0) {
          <span class="hd-info-sections__badges">
            @for (badge of section.badges; track badge) {
              <span class="hd-info-sections__badge">{{ badge }}</span>
            }
          </span>
        }
      </header>
      @if (section.facts.length > 0) {
        <dl class="hd-info-sections__facts">
          @for (fact of section.facts; track fact.label) {
            <div class="hd-info-sections__fact">
              <dt>{{ fact.label }}</dt>
              <dd>{{ fact.value }}</dd>
            </div>
          }
        </dl>
      }
      @if (isExpanded(section.key)) {
        @if (section.parts; as parts) {
          @for (part of parts; track part.key) {
            <div class="hd-info-sections__part" [attr.data-part-key]="part.key">
              <div class="hd-info-sections__part-header">
                <h5 class="hd-info-sections__part-title">{{ part.label }}</h5>
                @if (part.badge) {
                  <span class="hd-info-sections__badge">{{ part.badge }}</span>
                }
              </div>
              <markdown class="hd-info-sections__markdown" [src]="part.url" />
            </div>
          }
        } @else if (section.url) {
          <markdown class="hd-info-sections__markdown" [src]="section.url" />
        } @else if (section.markdown) {
          <markdown class="hd-info-sections__markdown" [data]="section.markdown" />
        }
      }
    </section>
  }

  @if (v.outroMarkdown) {
    <markdown class="hd-info-sections__markdown hd-info-sections__outro" [data]="v.outroMarkdown" />
  }
</section>
